<script lang="ts" setup>
import 'dayjs/locale/zh-cn'

import { App, ConfigProvider } from 'ant-design-vue'
import { storeToRefs } from 'pinia'
import { computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import { router } from '@/router'
import { PageEnum } from '@/enums/pageEnum'
import { useUserStore } from '@/store/modules/user'
import { AppProvider } from '@/components/Application'
import { useTitle } from '@/hooks/web/useTitle'
import { useLocale } from '@/locales/useLocale'
import { useAppStore } from '@/store/modules/app'
import { getAccessToken } from '@/utils/auth'
import { LINK } from '@/store/modules/useSocketStoreWithOut'


//import { useWebSocketStore } from '@/store/modules/useWebSocketStore'
// import { px2remTransformer } from '@ant-design/cssinjs'

let AMP_lINK = ''
const userStore = useUserStore()
//const webSocketStore = useWebSocketStore()

//const useVueNativeSockStoreFn = useVueNativeSockStore(appUseVue)

if (import.meta.env.MODE === 'development') {
  // 开发环境逻辑
  AMP_lINK = 'https://bn.chenlingkj.com.cn/'
  // hostLink = 'http://39.105.189.117:8085/'
}
else {
  // 其他环境逻辑
  AMP_lINK = `${window.location.origin}`
}
if (!(window as any)._AMapSecurityConfig) {
  (window as any)._AMapSecurityConfig = {
    serviceHost: `${AMP_lINK}/_AMapService`,
  }
}
// console.log('当前环境', import.meta.env.MODE, AMP_lINK)

// window._AMapSecurityConfig = {
//  serviceHost: 'https://bn.chenlingkj.com.cn/_AMapService',
// };

// support Multi-language
const { getAntdLocale } = useLocale()
const appStore = useAppStore()
const { themeConfig } = storeToRefs(appStore)

const componentSize = computed(() => appStore.getComponentSize)
// Listening to page changes and dynamically changing site titles
useTitle()
// console.log('App.vue', window.innerWidth)
// rem 适配
// const px2rem = px2remTransformer({
//  rootValue: 18.66667, // 32px = 1rem; @default 16
//  mediaQuery: false,
// })
//
// <dv-full-screen-container> 大屏适配，但是缺点是会把屏幕锁定

// let gap_time = 0
// let beforeUnload_time = 0
function setRefreshFlag() {
  // 在 sessionStorage 中设置一个标记
  sessionStorage.setItem('isRefreshing', 'true')

  // beforeUnload_time = new Date().getTime()
}
function checkAndClearLocalStorage() {
  // 判断是否是携带参数跳转过来的
  const searchLink = window.location.search
  if (searchLink.includes('Authorization') && searchLink.includes('TenantId'))
    return

  // 检查是否存在刷新标记
  const isRefreshing = sessionStorage.getItem('isRefreshing')
  if (!isRefreshing) {
    // 如果没有标记，说明是关闭浏览器窗口或标签页
    // const rememberMeLocal = localStorage.getItem('rememberMeLocal')
    // userStore.logout(true)
    // 执行一些清理操作
    userStore.setAccessToken(undefined)
    userStore.setSessionTimeout(false)
    userStore.setUserInfo(null)

    //  if (rememberMeLocal)
    // localStorage.setItem('rememberMeLocal', rememberMeLocal)
    router.push(PageEnum.BASE_LOGIN)
  }
  else {
    // 移除标记，以便下次刷新时不再误判
    sessionStorage.removeItem('isRefreshing')
  }
}

const { proxy } = getCurrentInstance() as any;
onMounted(async () => {
  // 在组件挂载时添加 beforeunload 事件监听器
  window.addEventListener('beforeunload', setRefreshFlag)

  // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
  // window.addEventListener('unload', unloadFn)

  //检查是否是页面刷新
  checkAndClearLocalStorage()

  // 判断当前是否存在token，如果存在token，则连接,点击登录的时候会再调用一遍的 （这个地方登录是防止租户跳转）
  if (getAccessToken()) {
    //初始化ws
    let url = await LINK()
    setTimeout(() => {
      if (proxy == null) return;
      proxy.$connect(url);//链接wss
      console.log('proxy', proxy.$socket);
    }, 100);
  }
})
onUnmounted(async () => {
  console.log('APP onUnmounted');
  //let url = await LINK()
  setTimeout(() => {
    if (proxy == null) return;
    //移除消息监听
    delete proxy.$socket.onmessage
    //关闭ws连接
    //proxy.$disconnect(url) //关闭指定ws
    proxy.$socket.close()
  }, 100)
  // 在组件卸载时移除 beforeunload 事件监听器
  window.removeEventListener('beforeunload', setRefreshFlag)

  // window.removeEventListener('unload', unloadFn)
})

// async function unloadFn() {
//  //gap_time = new Date().getTime() - beforeUnload_time
//  // alert('关闭浏览器窗口或标签页' + gap_time)
//  if (gap_time <= 10) {
//    // 执行一些清理操作
//    //userStore.setAccessToken(undefined)
//    //userStore.setSessionTimeout(false)
//    //userStore.setUserInfo(null)

//    //const rememberMeLocal = localStorage.getItem('rememberMeLocal')

//    localStorage.clear()
//    //sessionStorage.clear()

//    //if (rememberMeLocal)
//    //  localStorage.setItem('rememberMeLocal', rememberMeLocal)

//    //router.push(PageEnum.BASE_LOGIN)
//  }
// }

</script>

<template>
  <!-- <dv-full-screen-container> -->
  <!-- <a-style-provider :transformers="[px2rem]"> -->
  <ConfigProvider :locale="getAntdLocale" :theme="themeConfig" :component-size="componentSize">
    <App class="h-full w-full">
      <AppProvider>
        <RouterView />
      </AppProvider>
    </App>
  </ConfigProvider>
  <!-- </a-style-provider> -->
  <!-- </dv-full-screen-container> -->
</template>

<style lang="less">
* {
  font-family: "HarmonyOS Sans SC";
}

.alert-box {
  position: fixed;
  top: 5%;
  left: 45%;
  z-index: 19999;

  /* 确保在最顶层 */
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  background-color: rgb(84 161 255 /80%);
  border-radius: 5px;
  transform: all -50%, -50%;
}

.ant-modal div[aria-hidden="true"] {
  display: none !important
}
</style>
